import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

// Strict dropdown - only values that exist in the matching master can be chosen.
export const MasterSelect = ({ testId, options, value, onChange, placeholder, emptyHint, className = "mt-2 rounded-sm" }) => (
  <Select value={value || ""} onValueChange={onChange}>
    <SelectTrigger data-testid={testId} className={className}>
      <SelectValue placeholder={options.length ? placeholder : emptyHint || "Add options in Admin master"} />
    </SelectTrigger>
    <SelectContent>
      {options.length === 0 ? (
        <div className="px-2 py-3 text-xs text-zinc-500">{emptyHint || "Add options in the Admin master first"}</div>
      ) : (
        Array.from(new Set(options)).map((o, i) => (
          /* keys namespaced by index to tolerate duplicate names */
          <SelectItem key={`${o}-${i}`} value={o} data-testid={`${testId}-option-${o}`}>
            {o}
          </SelectItem>
        ))
      )}
    </SelectContent>
  </Select>
);
